<template>
  <page-wrapper v-bind="pageWrapper">
    <div class="header wrapper">
      <div class="row mb-3">
        <div class="col-3">
          <div class="label mb-2">ชื่อแพ็กเกจ</div>
          <el-input v-model="form.packageName" />
        </div>
        <div class="col-3">
          <div class="label mb-2">โครงการ</div>
          <project-select v-model="form.selectedProject"></project-select>
        </div>
      </div>
      <div class="text-end">
        <sc-button variant="primary" @click="handleClickSearch">ค้นหา</sc-button>
      </div>
    </div>
    <div v-if="total > 0" class="wrapper small">
      <p class="mb-2 mt-2">{{ totalCount }}</p>
    </div>
    <router-link
      v-for="presenter in requestedPackagePresenters"
      :key="presenter.key"
      :to="presenter.route"
      class="requested-package-item"
    >
      <h4 class="title">{{ presenter.name }}</h4>
      <p
        class="desc"
      >มี {{ presenter.numberOfRequested }} คน จาก {{ presenter.numberOfProjects }} โครงการ ต้องการ Package นี้</p>
    </router-link>
    <div v-if="list.length" class="wrapper small text-end mt-4">
      <el-pagination
        :total="total"
        :size="10"
        :current-page="queryParams.page"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <div v-else class="wrapper text-center">
      <h1>ไม่มีข้อมูล</h1>
    </div>
  </page-wrapper>
</template>

<script>
import { Input as ElInput, Pagination as ElPagination } from "element-ui";

import PageWrapper from "@/lib/components/PageWrapper";
import ProjectSelect from "@/lib/components/ProjectSelect";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { toCamelCaseObject } from "@/lib/util";
import { formatNumber } from "@/lib/formatter";

export default {
  components: { ElInput, ElPagination, PageWrapper, ProjectSelect, ScButton },
  data() {
    const list = [];
    const form = {
      packageName: "",
      selectedProject: null
    };
    const total = 0;

    return {
      list,
      form,
      total
    };
  },
  computed: {
    pageWrapper() {
      return {
        title: "Requested Package"
      };
    },
    requestedPackagePresenters() {
      return this.list.map((requested) => {
        const key = requested.packageId;
        const name = requested.packageName;
        const numberOfProjects = formatNumber(requested.projectCount);
        const numberOfRequested = formatNumber(requested.requestCount);
        const id = key;
        const route = { name: "RequestedPackageDetailPage", params: { id } };

        return { key, name, numberOfProjects, numberOfRequested, route };
      });
    },
    totalCount() {
      const limit = 10;
      const totalNumber = this.total;
      const currentTotalItem = this.list.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.queryParams.page;
      const endNumber = isLastPage ? totalNumber : currentPage * limit;
      const startNumber = (isLastPage ? limit * currentPage - limit : endNumber - limit) + 1;
      const end = endNumber.toLocaleString();
      const start = startNumber.toLocaleString();
      const total = totalNumber.toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    queryParams() {
      const parsedPage = parseInt(this.$route.query.page, 10) || 1;
      const page = parsedPage > 0 ? parsedPage : 1;
      const packageName = this.$route.query.packageName
        ? this.$route.query.packageName.trim()
        : null;

      return {
        page,
        packageName: packageName || null,
        projectId: this.$route.query.projectId || null
      };
    }
  },
  watch: {
    "$route.query": "setupData"
  },
  mounted() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupQuery();
      this.setupData();
    },
    setupQuery() {
      this.form = {
        packageName: this.queryParams.packageName,
        selectedProject: this.queryParams.projectId
          ? { projectId: this.queryParams.projectId }
          : null
      };
    },
    async setupData() {
      const { requestPackages, count } = await this.fetchList();

      this.list = requestPackages;
      this.total = count;
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.getRequestPackage(this.queryParams);

      return toCamelCaseObject(response.data.result);
    },
    handleClickSearch() {
      this.$router.replace({
        query: {
          ...this.$route.query,
          page: 1,
          packageName: this.form.packageName,
          projectId: this.form.selectedProject && this.form.selectedProject.projectId
        }
      });
    },
    handleCurrentChange(page) {
      this.$router.replace({ query: { ...this.$route.query, page } });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  background: #f9f9f9;
  border-bottom: 1px solid #e0e0e0;
}

.wrapper {
  padding: 2rem;
}

.wrapper.small {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.requested-package-item {
  display: block;
  padding: 0.5rem 2rem;

  &:hover {
    text-decoration: none;
    background: #f0f0f0;
  }

  > .title,
  > .desc {
    margin: 0;
    line-height: 1.7;
  }

  > .title {
    font-size: 1rem;
    font-weight: normal;
  }

  > .desc {
    color: #888;
    font-size: 0.875rem;
  }
}
</style>
